import { render } from "./ColorSquare.vue?vue&type=template&id=271e4ccc"
import script from "./ColorSquare.vue?vue&type=script&lang=js"
export * from "./ColorSquare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__